import styled from '@emotion/styled/macro';
import { forTabletLandscapeDown, Variables } from '@enter/core';

export const Main = styled.main<{ sidebarOpened: boolean }>`
    display: flex;
    flex-direction: column;

    height: 100vh;
    max-height: 100vh;
    /* width: 100%; */

    margin-left: ${({ sidebarOpened }) => (!sidebarOpened ? 'unset' : Variables.sidebarSize)};

    /* margin-left: ${({ sidebarOpened }) => (sidebarOpened ? Variables.sidebarSize : 0)}; */

    color: ${Variables.Colors.p500};
    background-color: ${Variables.Colors.ghostWhite};
    z-index: 1;
    padding-top: ${Variables.topnavSize};

    transition: margin 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;

    ${forTabletLandscapeDown(`
        margin-left: 0;
        width: initial;
        height: 100vh;
        max-height: 100vh;
    `)};
    /* position: relative; */
    overflow: auto;
`;
